export default __webpack_public_path__ + "static/media/close.7398fac0.webp";